import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
const Breadcrumb = ({ title }) => {
  return (
    <div className='d-flex flex-wrap align-items-center justify-content-between gap-2 mb-10'>
      <ul className='d-flex align-items-center gap-2 mb-0 ps-0' style={{ listStyle: 'none', minHeight: '10px' }}>
        <li className='fw-medium'>
          <Link
            to='/'
            className='d-flex align-items-center gap-1 hover-text-primary text-sm'
          >
            <Icon
              icon='solar:home-smile-angle-outline'
              className='icon'
            />
            Admin
          </Link>
        </li>
        <li className='text-secondary-light text-sm'>/</li>
        <li className='fw-medium text-sm'>{title}</li>
      </ul>
    </div>
  );
};

export default Breadcrumb;
